import React from 'react';
import { TextField } from '@mui/material';
import { FastField, getIn } from 'formik';

const TextFieldFormik = ({
                             name,
                             label,
                             size,
                             required,
                             placeholder,
                             type,
                             multiline,
                             rows,
                             disabled,
                             inputProps,
                             inputLabelProps,
                             onChange,
                             onKeyDown,
                             onFocus,
                             style,
                             variant
                         }) => (
    <FastField
        name={ name }
        shouldUpdate={ (nextProps, currentProps) => {
            if (getIn(nextProps.formik.values, name) !== getIn(currentProps.formik.values, name)) return true;
            if (getIn(nextProps.formik.errors, name) !== getIn(currentProps.formik.errors, name)) return true;
            if (getIn(nextProps.formik.touched, name) !== getIn(currentProps.formik.touched, name)) return true;
            if (nextProps.disabled !== currentProps.disabled) return true;
            if (nextProps.required !== currentProps.required) return true;
            if (nextProps.label !== currentProps.label) return true;

            return false;
        } }
    >
        { ({ form: { errors, setFieldValue, touched }, field }) => (
            <TextField
                fullWidth
                { ...field }
                label={ label }
                size={ size }
                required={ required }
                type={ type }
                error={ !!getIn(errors, field?.name) }
                helperText={ getIn(errors, field?.name) }
                placeholder={ placeholder }
                multiline={ multiline }
                minRows={ rows }
                disabled={ disabled }
                onChange={ (event) => {
                    const value = type === 'number'
                        ? (parseFloat(event.target.value) || event.target.value)
                        : event.target.value;
                    setFieldValue(name, value);
                    onChange && onChange(value);
                } }
                onBlur={ (e) => {
                    field.onBlur(e);
                    if (type === 'number' && e.target.value !== '') {
                        const val = parseFloat(e.target.value);
                        if (!isNaN(val) && inputProps?.step === '0.01') {
                            setFieldValue(name, val.toFixed(2));
                        }
                    }
                } }
                onKeyDown={ onKeyDown }
                onFocus={ onFocus }
                style={ style }
                inputProps={ {
                    ...inputProps,
                    style: {
                        textAlign: type === 'number' ? 'right' : 'left',
                        ...inputProps?.style
                    }
                } }
                onWheel={ e => type === 'number' && e.target.blur() }
                InputLabelProps={ inputLabelProps }
                variant={ variant }
            />
        ) }
    </FastField>
);

export default TextFieldFormik;